import React, { useEffect, useState } from "react";
import api from "../../api/api"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { emailrgx } from "../../assets/constant";
import { useAuth } from "../../context/AuthContext";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
const AddUser = (prop) => {
  const { t } = useTranslation();

      const {user} = useAuth();
    const schema = yup.object({
      email: yup
        .string()
        .matches(emailrgx, "Email format is required")
        .required("Email is required")
        .trim(),
    });
    const {
      reset,
      handleSubmit,
      control,
      register,
      setError,
      clearErrors,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      //defaultValues: inputValues,
    });


     const [loadingSendInv,setloadingSendInv] = useState(false)
     const [successinvite,setsuccessinvite] = useState(null)
    const { onRefresh } = prop;

     
     const onSubmit = async(data) => {
        clearErrors();
        setsuccessinvite(null)
        let typeurl;
        if(user.type == "agency")typeurl="/invite-agency/"
        else if (user.type == "supplier")typeurl="/invite-supplier/"
        else return

        if (loadingSendInv) return;
        setloadingSendInv(true);
        
        
        try {


            const response = await api.post(typeurl, data ); 

            
            console.log("Response Code:", response.status);

 
            console.log("Form submitted successfully!");
            reset();
            setsuccessinvite(response.data['result'])

            if (onRefresh) onRefresh();

            document.querySelector('#add_user .btn-close')?.click();

        } catch (error) {
       
           let  errorMessage = ""
            // Extract response code if available
            const responseCode = error.response ? error.response.status : "Unknown";
            console.log("Response Code:", responseCode);
            if (error?.response?.data) {
                
                 Object.entries(error.response.data).forEach(([key, values]) => {
                   //if (key !== "token" && key !== "agency") {
                     console.log(key, values);
                     errorMessage += `${values}\n`;
                   //}
                 });
               }
             
               // If no specific error was found, provide a default message
               if (!errorMessage) {
                
                 errorMessage = "An unknown error occurred.";
               }
               
               // Set the error message in React Hook Form
               setError("root", { type: "server", message: errorMessage });
   
        } finally {
            setloadingSendInv(false);
        }
    }
        useEffect(()=>{
               
             
            clearErrors();
            },[])
    return (
        <div className="modal custom-modal modal-lg fade" id="add_user" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header border-0 pb-0">
                        <div className="form-header modal-header-title text-start mb-0">
                            <h4 className="mb-0">{t("Add User")}</h4>
                        </div>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form  onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-body">
                                        <div className="form-groups-item">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="input-block mb-3">
                                                        <label>{t("Email")}</label>
                                                        <input type="email"
                                                         {...register("email")}
                                                          className="form-control"  />
                                                        <small className="text-danger">{t(errors?.email?.message)}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                        {/* <small  style={{color:"green"}}> {successinvite && <p>Your invitation was successfully delivered to <b>{successinvite}</b></p>}</small> */}
                        <small  style={{color:"red"}}> {errors.root && <p>{errors.root.message}</p>}</small>
                        <div className="d-flex justify-content-end w-100 mt-2">
                            <button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">{t("Cancel")}</button>
                            <button type="submit"  className="btn btn-primary ">{t("Add User")}
                            {loadingSendInv && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }
                            
                            </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    ); 
};
AddUser.propTypes = {
    refreshData: PropTypes.func.isRequired,
  };
export default AddUser;
